import { render, staticRenderFns } from "./buildingManage.vue?vue&type=template&id=24b47ee4&scoped=true&"
import script from "./buildingManage.vue?vue&type=script&lang=js&"
export * from "./buildingManage.vue?vue&type=script&lang=js&"
import style0 from "./buildingManage.vue?vue&type=style&index=0&id=24b47ee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b47ee4",
  null
  
)

export default component.exports